import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";
import HomePage from "./pages/HomePage";
import SearchResults from "./pages/SearchResults";
import AdminLogin from "./pages/AdminLogin";
import ClientLogin from "./pages/ClientLogin";
import ProtectedRoute from "./components/ProtectedRoute";
import ClientProtectedRoute from "./components/ClientProtectedRoute";
import WelcomePopup from "./components/WelcomePopup";
import PromoBar from "./components/PromoBar";
import { AuthProvider } from "./contexts/AuthContext";
import { ClientAuthProvider } from "./contexts/ClientAuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import "./App.css";

// Lazy-loaded pages (code-split — only loaded when navigated to)
const TermsPage = lazy(() => import("./pages/TermsPage"));
const FAQPage = lazy(() => import("./pages/FAQPage"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const ClientDashboard = lazy(() => import("./pages/ClientDashboard"));
const ClientAnnouncements = lazy(() => import("./pages/ClientAnnouncements"));
const ClientTutorials = lazy(() => import("./pages/ClientTutorials"));
const ClientSupport = lazy(() => import("./pages/ClientSupport"));
const ClientDocuments = lazy(() => import("./pages/ClientDocuments"));
const ClientMesCodes = lazy(() => import("./pages/ClientMesCodes"));

const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <Loader2 className="w-8 h-8 animate-spin text-indigo-500" />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <LanguageProvider>
          <AuthProvider>
            <ClientAuthProvider>
              <BrowserRouter>
                <PromoBar />
                <Suspense fallback={<PageLoader />}>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/searchresults" element={<SearchResults />} />
                  <Route path="/terms" element={<TermsPage />} />
                  <Route path="/faq" element={<FAQPage />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route
                    path="/admin"
                    element={
                      <ProtectedRoute>
                        <AdminDashboard />
                      </ProtectedRoute>
                    }
                  />
                  {/* Client Portal Routes */}
                  <Route path="/espaceclient/login" element={<ClientLogin />} />
                  <Route path="/espaceclient/dashboard" element={<ClientProtectedRoute><ClientDashboard /></ClientProtectedRoute>} />
                  <Route path="/espaceclient/announcements" element={<ClientProtectedRoute><ClientAnnouncements /></ClientProtectedRoute>} />
                  <Route path="/espaceclient/tutorials" element={<ClientProtectedRoute><ClientTutorials /></ClientProtectedRoute>} />
                  <Route path="/espaceclient/support" element={<ClientProtectedRoute><ClientSupport /></ClientProtectedRoute>} />
                  <Route path="/espaceclient/documents" element={<ClientProtectedRoute><ClientDocuments /></ClientProtectedRoute>} />
                  <Route path="/espaceclient/mes-codes" element={<ClientProtectedRoute><ClientMesCodes /></ClientProtectedRoute>} />
                </Routes>
                </Suspense>
                <WelcomePopup />
              </BrowserRouter>
            </ClientAuthProvider>
          </AuthProvider>
        </LanguageProvider>
      </div>
    </HelmetProvider>
  );
}

export default App;
